<template>
	<div class="footer flex align-center justify-space-between" :class="{'above':position === 'above'}">
		<div>
			<!-- disclaimer: '免責聲明',
			privacy_policy_statement: '私隱與政策',
			security_information: '保安資訊',
			risk_disclosure_statement: '風險披露聲明',
			telephone: '諮詢電話' -->
			<span class="link hidden-xs-only">
				<a :href="url0" target="_blank">{{$t('footer.disclaimer')}}</a>&nbsp;|&nbsp;
				<a :href="url1" target="_blank">{{$t('footer.privacy_policy_statement')}}</a>&nbsp;|&nbsp;
				<a :href="url2" target="_blank">{{$t('footer.security_information')}}</a>&nbsp;|&nbsp;
				<a :href="url3" target="_blank">{{$t('footer.risk_disclosure_statement')}}</a><br>
			</span>
			<span class="link hidden-sm-and-up">
				<span>© 2018 EDDID.COM</span> &nbsp;<span>{{$t('footer.telephone')}} + 400-8428-393</span><br>
				<a :href="url0" target="_blank">{{$t('footer.disclaimer')}}</a>&nbsp;&nbsp;|&nbsp;&nbsp;
				<a :href="url1" target="_blank">{{$t('footer.privacy_policy_statement')}}</a>&nbsp;&nbsp;|&nbsp;&nbsp;
				<a :href="url2" target="_blank">{{$t('footer.security_information')}}</a>&nbsp;&nbsp;|&nbsp;&nbsp;
				<a :href="url3" target="_blank">{{$t('footer.risk_disclosure_statement')}}</a>
				<!-- <b>{{$t('footer.telephone')}} +852 2655 0338</b> -->
			</span>
		</div>
		<div class="hidden-xs-only">
			<b>{{$t('footer.telephone')}} +852 2655 0338</b>
		</div>
	</div>
</template>

<script>
// import Vue from 'vue'
import { getAgreementContent } from '@/api/v2/deposit.js'
export default {
  name: 'Footer',
  props: ['position'],
  data () {
    return {
      url0: '',
      url1: '',
      url2: '',
      url3: '',
      cn: [
        {
          link: 'https://middleware-agreement-prod-public.oss-cn-shenzhen.aliyuncs.com/2021-08/d88de3cc-17f1-46de-aed1-4d65ccd0ed50',
          name: '免责声明'
        },
        {
          link: 'https://middleware-agreement-prod-public.oss-cn-shenzhen.aliyuncs.com/2021-08/95e7e3ed-70ee-4315-9854-863bf9144bdd',
          name: '隐私与政策'
        },
        {
          link: 'https://middleware-agreement-prod-public.oss-cn-shenzhen.aliyuncs.com/2021-08/166c4a7b-d984-46b9-9d4a-9e297df61e76',
          name: '保安资讯'
        },
        {
          link:
            'https://download.eddidapp.com/pdf/SC/Risk-Disclosure-Statement.pdf',
          name: '风险披露声明'
        }
      ],
      us: [
        {
          link: 'http://download.eddidapp.com/page/disclaimer/index.html',
          name: 'Disclaimer'
        },
        {
          link:
            'http://download.eddidapp.com/pdf/SC/privacy-policy-statement.pdf',
          name: 'Privacy Policy Statement'
        },
        {
          link: 'http://download.eddidapp.com/page/securityguard/index.html',
          name: 'Security information'
        },
        {
          link:
            'http://download.eddidapp.com/pdf/SC/Risk-Disclosure-Statement.pdf',
          name: 'Risk Disclosure Statement'
        }
      ],
      hk: [
        {
          link: 'https://middleware-agreement-prod-public.oss-cn-shenzhen.aliyuncs.com/2021-08/5cb638f6-378f-47e4-8611-0eef7993492a',
          name: '免責聲明'
        },
        {
          link:
            'https://middleware-agreement-prod-public.oss-cn-shenzhen.aliyuncs.com/2021-08/4dc5ad52-9fe4-4a91-a172-655fa3da4d8c',
          name: '私隱與政策'
        },
        {
          link: 'https://middleware-agreement-prod-public.oss-cn-shenzhen.aliyuncs.com/2021-09/a77a39b2-5928-4288-9d6f-3ef7d2529e05',
          name: '保安資訊'
        },
        {
          link:
            'https://download.eddidapp.com/pdf/TC/Risk-Disclosure-Statement.pdf',
          name: '風險披露聲明'
        }
      ],
      linkMap: {
        'Disclaimer': 'url0',
        'Privacy_Policy_Disclaimer': 'url1',
        'Safety_Info': 'url2',
        'RISK_DISCLOSURE': 'url3'
      }
    }
  },
  created () {
    // let curLang = sessionStorage.getItem('language') ? sessionStorage.getItem('language') : 'cn'
    // Vue.setLanguage = data => {
    //   [0, 1, 2, 3].forEach(i => {
    //     this[`url${i}`] = this[data][i].link
    //   })
    // }
    // Vue.setLanguage(curLang)
    console.log(22222222222222)
    this.getAgreementContentFun('Disclaimer')
    this.getAgreementContentFun('Privacy_Policy_Disclaimer')
    this.getAgreementContentFun('Safety_Info')
    this.getAgreementContentFun('RISK_DISCLOSURE')
  },
  methods: {
    // 获取协议地址
    async getAgreementContentFun(type) {
      let params = {
        platform: 'H5',
        type
      }
      let res = await getAgreementContent(params)
      if (res.code === 200) {
        this[this.linkMap[type]] = res.data && res.data.path
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_variables';
@import '../assets/scss/_mixins';

.footer {
	width: 100%;
	height: 60px;
	padding: 0 20px;
	box-sizing: border-box;
	background: #192B57;
	margin-top: 2px;
	font-size: 14px;

	&.above {
		box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
		z-index: 1;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		border-radius: 0;
	}

	b, span {
		color: #fff;
	}
	span.link {
		color: #fec000;
		a {
			color: inherit;
			text-decoration-color: #fec000;
		}
	}

	.buy-btn {
		margin-left: 10px;
	}
}

@media (max-width: 768px) {
	.footer {
    height: auto;
    padding: 6px 10px;
    font-size: 12px;
    z-index: 2018;
	}
}
</style>
